export const documentProps = {
  title: 'Business Operations Automation Solutions',
  description:
    'Three proven automation products: Client Intake Automation, Internal Knowledge Assistant, and Executive Dashboard. Starting at $3,000. Built in weeks, not months.',
};
